import client from './client';

export type CostPeriod = '1d' | '7d' | '30d' | 'custom';

export interface CostWindowParams {
  period?: CostPeriod;
  start?: string; // ISO-8601
  end?: string; // ISO-8601
}

export interface CostWindow {
  period: CostPeriod;
  start: string;
  end: string;
}

export interface TenantCostRow {
  tenant_id: string;
  total_cost_usd: string; // server serialises Decimal as string
  event_count: number;
  distinct_products: number;
  last_event_at: string | null;
}

export interface TenantCostResponse {
  window: CostWindow;
  rows: TenantCostRow[];
}

export interface ProductCostRow {
  product: string;
  total_cost_usd: string;
  event_count: number;
  distinct_instances: number;
  last_event_at: string | null;
}

export interface ProductCostResponse {
  window: CostWindow;
  tenant_id: string;
  rows: ProductCostRow[];
}

export interface ServiceCostRow {
  product_instance: string;
  service_name: string | null;
  total_cost_usd: string;
  event_count: number;
  avg_duration_ms: number | null;
  p95_duration_ms: number | null;
  last_event_at: string | null;
}

export interface ServiceCostResponse {
  window: CostWindow;
  tenant_id: string;
  product: string;
  rows: ServiceCostRow[];
}

export async function fetchTenantCosts(params?: CostWindowParams): Promise<TenantCostResponse> {
  const { data } = await client.get<TenantCostResponse>('/tenants/costs', { params });
  return data;
}

export async function fetchProductCosts(
  tenantId: string,
  params?: CostWindowParams,
): Promise<ProductCostResponse> {
  const { data } = await client.get<ProductCostResponse>(
    `/tenants/${encodeURIComponent(tenantId)}/products/costs`,
    { params },
  );
  return data;
}

export async function fetchServiceCosts(
  tenantId: string,
  product: string,
  params?: CostWindowParams,
): Promise<ServiceCostResponse> {
  const { data } = await client.get<ServiceCostResponse>(
    `/tenants/${encodeURIComponent(tenantId)}/products/${encodeURIComponent(product)}/services/costs`,
    { params },
  );
  return data;
}
